/*!

=========================================================
* Light Bootstrap Dashboard React - v2.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {Component, useMemo, useState} from "react";
import { useLocation } from "react-router-dom";
import { Navbar, Container, Nav, Dropdown, Button } from "react-bootstrap";
import _ from "lodash";
import clsx from "clsx";
import Image from "react-bootstrap/Image";
import { useHistory } from "react-router";
import PAGE from "../../utils/Destination";
import { useDispatch, useSelector } from "react-redux";
import * as userSelectors from "../../selectors/user";
import * as axiosInstance from "../../services/axiosInstance";
import * as userActions from "../../action/user";
import Helper from "../../utils/Helper";
import CustomConfirmationModal from "../CustomConfirmationModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import * as paymentActions from "../../action/payment";

function Header() {
  const oldHistory = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [toogle, setToogle] = useState(false);
  const [show, setShow] = useState(false);
  const [history, setHistory] = useState(oldHistory);
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.user);
  const accountSelections = userSelectors.getUserAccountSelections(userState);
  const selectedAccount = _.find(accountSelections, "is_selected");
  const currenciesSelections = userSelectors.getUserAccountSelectionsCurrencies(selectedAccount);
  const selectedCurrency = _.find(currenciesSelections, "is_selected");

  useMemo(()=>{
    setHistory(oldHistory)
  },[oldHistory])
  const mobileSidebarToggle = (e) => {
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function () {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    document.body.appendChild(node);
  };

  const onClickSwitchCode = (e, clientCode, currencyCode) => {
    e.preventDefault();
    if (_.isEqual(clientCode, userSelectors.getUserAccountText(selectedAccount))) {
      return;
    }
    if (_.isEqual(currencyCode, userSelectors.getUserAccountText(selectedCurrency))) {
      return;
    }
    submitSwitchCodeRequest({
      client_code: !_.isEmpty(clientCode) ? clientCode : userSelectors.getUserAccountText(selectedAccount),
      currency_code: !_.isEmpty(currencyCode)
        ? currencyCode
        : userSelectors.getUserAccountKey(selectedCurrency),
    });
  };

  const submitSwitchCodeRequest = async (postData) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("clientarea/profile/switch-client", postData);
      dispatch(userActions.updateUserDetail(response.data));
      window.location.reload();
    } catch (e) {
      Helper.handleHttpError(e, dispatch);
    } finally {
      setLoading(false);
    }
  };

  const onClickNavigate = (e, page, queryParam) => {
    e.preventDefault();
    mobileSidebarToggle(e);
    history.push(`${page}${!_.isEmpty(queryParam) ? `?${queryParam}` : ""}`);
    setToogle(false);
  };

  const onClickLogout = () => {
    setShow(true);
  };

  const startLogout = async() => {
    setLoading(true)
    try {
      const response = await axiosInstance.post(
        "clientarea/profile/logout",
        null,
        false,
        false,
        "",
      );
      if (response && response.status) {
        localStorage.removeItem("ta-token");
        history.push(`/`);
      }
    } catch (error) {

    } finally {
      setLoading(false);
    }

  };
  return (
    <Navbar
      bg="light"
      expand="lg"
      onToggle={(value) => setToogle(value)}
      expanded={toogle}
    >
      <Container fluid>
        <div className="d-flex justify-content-center align-items-center ml-2 ml-lg-0">
          <a
            href={`${PAGE.DASHBOARD}`}
            className="d-lg-none p-1"
            onClick={(e) => onClickNavigate(e, PAGE.DASHBOARD)}
          >
            <Image
              src="/img/ta-securities-logo.png"
              className="brandLogo"
              alt="logo"
              style={{ height: "32px" }}
            />
          </a>
        </div>

        <Navbar.Toggle aria-controls="basic-navbar-nav" className="mr-2">
          <span className="navbar-toggler-bar burger-lines"></span>
          <span className="navbar-toggler-bar burger-lines"></span>
          <span className="navbar-toggler-bar burger-lines"></span>
        </Navbar.Toggle>

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="nav mr-auto" navbar>
            <Nav.Item>
              <Nav.Link
                className={clsx("m-0", {
                  ["active"]: _.isEqual(
                    PAGE.DASHBOARD,
                    _.get(history, ["location", "pathname"]),
                  ),
                })}
                href={`${PAGE.DASHBOARD}`}
                onClick={(e) => onClickNavigate(e, PAGE.DASHBOARD)}
              >
                <span className="d-lg-block">Dashboard</span>
              </Nav.Link>
            </Nav.Item>
            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle
                as={Nav.Link}
                data-toggle="dropdown"
                id="dropdown-67443507"
                variant="default"
                className={clsx("m-0", {
                  ["active"]:
                  _.isEqual(
                    PAGE.EIPO,
                    _.get(history, ["location", "pathname"]),
                  ) ||
                  _.isEqual(
                    PAGE.EIPO_HISTORY,
                    _.get(history, ["location", "pathname"]),
                  ),
                })}
              >
                <span className="d-lg-block">IPO</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  className={clsx("m-0", {
                    ["active"]: _.isEqual(
                      PAGE.EIPO,
                      _.get(history, ["location", "pathname"]),
                    ),
                  })}
                  href={`${PAGE.EIPO}`}
                  onClick={(e) =>
                    onClickNavigate(
                      e,
                      PAGE.EIPO,
                    )
                  }
                  style={{textTransform: "none"}}
                >
                  E-IPO
                </Dropdown.Item>
                <Dropdown.Item
                  className={clsx("m-0", {
                    ["active"]: _.isEqual(
                      PAGE.EIPO_HISTORY,
                      _.get(history, ["location", "pathname"]),
                    ),
                  })}
                  href={`${PAGE.EIPO_HISTORY}`}
                  onClick={(e) => onClickNavigate(e, PAGE.EIPO_HISTORY)}
                >
                  e-IPO History
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>


            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle
                  as={Nav.Link}
                  data-toggle="dropdown"
                  id="dropdown-67443507"
                  variant="default"
                  className={clsx("m-0", {
                    ["active"]:
                    _.isEqual(
                        PAGE.SET_OFF,
                        _.get(history, ["location", "pathname"]),
                    ) ||
                    _.isEqual(
                        PAGE.SET_OFF_HISTORY,
                        _.get(history, ["location", "pathname"]),
                    ),
                  })}
              >
                <span className="d-lg-block">Setoff</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  className={clsx("m-0", {
                    ["active"]: _.isEqual(
                      PAGE.SET_OFF,
                      _.get(history, ["location", "pathname"]),
                    ),
                  })}
                  href={`${PAGE.SET_OFF}?ts=${Math.floor(new Date() / 1000).toString()}&is_due=0`}
                  onClick={(e) =>
                    onClickNavigate(
                      e,
                      PAGE.SET_OFF,
                      `ts=${Math.floor(new Date() / 1000).toString()}&is_due=0`,
                    )
                  }
                  style={{textTransform: "none"}}
                >
                  e-Setoff
                </Dropdown.Item>
                <Dropdown.Item
                  className={clsx("m-0", {
                    ["active"]: _.isEqual(
                      PAGE.SET_OFF_HISTORY,
                      _.get(history, ["location", "pathname"]),
                    ),
                  })}
                  href={`${PAGE.SET_OFF_HISTORY}`}
                  onClick={(e) => onClickNavigate(e, PAGE.SET_OFF_HISTORY)}
                >
                  Setoff History
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle
                  as={Nav.Link}
                  data-toggle="dropdown"
                  id="dropdown-67443507"
                  variant="default"
                  className={clsx("m-0", {
                    ["active"]:
                    _.isEqual(
                        PAGE.E_PAYMENT,
                        _.get(history, ["location", "pathname"]),
                    ) ||
                    _.isEqual(
                        PAGE.PAYMENT_HISTORY,
                        _.get(history, ["location", "pathname"]),
                    ),
                  })}
              >
                <span className="d-lg-block">Payment</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                    className={clsx("m-0", {
                      ["active"]: _.isEqual(
                          PAGE.E_PAYMENT,
                          _.get(history, ["location", "pathname"]),
                      ),
                    })}
                    href={`${PAGE.E_PAYMENT}`}
                    onClick={(e) =>
                        onClickNavigate(
                            e,
                            PAGE.E_PAYMENT,
                            `ts=${Math.floor(new Date() / 1000).toString()}&is_due=0`,
                        )
                    }
                    style={{textTransform: "none"}}
                >
                  e-Payment
                </Dropdown.Item>
                <Dropdown.Item
                    className={clsx("m-0", {
                      ["active"]: _.isEqual(
                          PAGE.PAYMENT_HISTORY,
                          _.get(history, ["location", "pathname"]),
                      ),
                    })}
                    href={`${PAGE.PAYMENT_HISTORY}`}
                    onClick={(e) => onClickNavigate(e, PAGE.PAYMENT_HISTORY)}
                >
                  Payment History
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle
                  as={Nav.Link}
                  data-toggle="dropdown"
                  id="dropdown-67443507"
                  variant="default"
                  className={clsx("m-0", {
                    ["active"]:
                    _.isEqual(
                        PAGE.WITHDRAWAL,
                        _.get(history, ["location", "pathname"]),
                    ) ||
                    _.isEqual(
                        PAGE.WITHDRAW_TRANSACTION,
                        _.get(history, ["location", "pathname"]),
                    ),
                  })}
              >
                <span className="d-lg-block">Withdrawal</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                    href={`${PAGE.WITHDRAWAL}`}
                    onClick={(e) =>
                        onClickNavigate(
                            e,
                            PAGE.WITHDRAWAL,
                            `ts=${Math.floor(new Date() / 1000).toString()}`,
                        )
                    }
                    className={clsx("m-0", {
                      ["active"]: _.isEqual(
                          PAGE.WITHDRAWAL,
                          _.get(history, ["location", "pathname"]),
                      ),
                    })}
                    style={{textTransform: "none"}}
                >
                  e-Withdrawal
                </Dropdown.Item>
                <Dropdown.Item
                    href={`${PAGE.WITHDRAW_TRANSACTION}`}
                    onClick={(e) => onClickNavigate(e, PAGE.WITHDRAW_TRANSACTION)}
                    className={clsx("m-0", {
                      ["active"]: _.isEqual(
                          PAGE.WITHDRAW_TRANSACTION,
                          _.get(history, ["location", "pathname"]),
                      ),
                    })}
                >
                  Withdrawal History
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle
                  as={Nav.Link}
                  data-toggle="dropdown"
                  id="dropdown-67443507"
                  variant="default"
                  className={clsx("m-0", {
                    ["active"]:
                    _.isEqual(
                        PAGE.E_DEPOSIT,
                        _.get(history, ["location", "pathname"]),
                    ) ||
                    _.isEqual(
                        PAGE.DEPOSIT_TRANSACTION,
                        _.get(history, ["location", "pathname"]),
                    ),
                  })}
              >
                <span className="d-lg-block">Deposit</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                    className={clsx("m-0", {
                      ["active"]: _.isEqual(
                          PAGE.E_DEPOSIT,
                          _.get(history, ["location", "pathname"]),
                      ),
                    })}
                    href={`${PAGE.E_DEPOSIT}`}
                    onClick={(e) => onClickNavigate(e, PAGE.E_DEPOSIT)}
                    style={{textTransform: "none"}}
                >
                  e-Deposit
                </Dropdown.Item>
                <Dropdown.Item
                    className={clsx("m-0", {
                      ["active"]: _.isEqual(
                          PAGE.DEPOSIT_TRANSACTION,
                          _.get(history, ["location", "pathname"]),
                      ),
                    })}
                    href={`${PAGE.DEPOSIT_TRANSACTION}`}
                    onClick={(e) => onClickNavigate(e, PAGE.DEPOSIT_TRANSACTION)}
                >
                  Deposit History
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle
                  as={Nav.Link}
                  data-toggle="dropdown"
                  id="dropdown-67443507"
                  variant="default"
                  className={clsx("m-0", {
                    ["active"]:
                    _.isEqual(
                        PAGE.OUTSTANDING_STATEMENT,
                        _.get(history, ["location", "pathname"]),
                    ) ||
                    _.isEqual(
                        PAGE.DAILY_BUSINESS_REPORT,
                        _.get(history, ["location", "pathname"]),
                    ) ||
                    _.isEqual(
                        PAGE.MARGIN_STATEMENT,
                        _.get(history, ["location", "pathname"]),
                    ),
                  })}
              >
                <span className="d-lg-block">Reports</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                    className={clsx("m-0", {
                      ["active"]: _.isEqual(
                          PAGE.OUTSTANDING_STATEMENT,
                          _.get(history, ["location", "pathname"]),
                      ),
                    })}
                    href={`${PAGE.OUTSTANDING_STATEMENT}`}
                    onClick={(e) => onClickNavigate(e, PAGE.OUTSTANDING_STATEMENT)}
                >
                  Outstanding Positions
                </Dropdown.Item>
                <Dropdown.Item
                    className={clsx("m-0", {
                      ["active"]: _.isEqual(
                          PAGE.DAILY_BUSINESS_REPORT,
                          _.get(history, ["location", "pathname"]),
                      ),
                    })}
                    href={`${PAGE.DAILY_BUSINESS_REPORT}`}
                    onClick={(e) => onClickNavigate(e, PAGE.DAILY_BUSINESS_REPORT)}
                >
                  Daily Business Done
                </Dropdown.Item>
                <Dropdown.Item
                    className={clsx("m-0", {
                      ["active"]: _.isEqual(
                          PAGE.MARGIN_STATEMENT,
                          _.get(history, ["location", "pathname"]),
                      ),
                    })}
                    href={`${PAGE.MARGIN_STATEMENT}`}
                    onClick={(e) => onClickNavigate(e, PAGE.MARGIN_STATEMENT)}
                >
                  Margin Statement
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Nav.Item>
              <Nav.Link
                className={clsx("m-0", {
                  ["active"]: _.isEqual(
                    PAGE.ACTIVITY_LOG,
                    _.get(history, ["location", "pathname"]),
                  ),
                })}
                href={`${PAGE.ACTIVITY_LOG}`}
                onClick={(e) => onClickNavigate(e, PAGE.ACTIVITY_LOG)}
              >
                <span className="d-lg-block">Activity Log</span>
              </Nav.Link>
            </Nav.Item>
            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle
                as={Nav.Link}
                data-toggle="dropdown"
                id="dropdown-67443507"
                variant="default"
                className={clsx("m-0", {
                  ["active"]:
                    _.isEqual(
                      PAGE.P_AND_L_CALCULATOR,
                      _.get(history, ["location", "pathname"]),
                    ) ||
                    _.isEqual(
                      PAGE.MARGIN_CALCULATOR,
                      _.get(history, ["location", "pathname"]),
                    ),
                })}
              >
                <span className="d-lg-block">Tools</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  className={clsx("m-0", {
                    ["active"]: _.isEqual(
                      PAGE.P_AND_L_CALCULATOR,
                      _.get(history, ["location", "pathname"]),
                    ),
                  })}
                  href={`${PAGE.P_AND_L_CALCULATOR}`}
                  onClick={(e) => onClickNavigate(e, PAGE.P_AND_L_CALCULATOR)}
                >
                  Profit & Loss Calculator
                </Dropdown.Item>
                {/*<Dropdown.Item*/}
                {/*  className={clsx("m-0", {*/}
                {/*    ["active"]: _.isEqual(PAGE.MARGIN_CALCULATOR, _.get(history, ["location", "pathname"])),*/}
                {/*  })}*/}
                {/*  href={`${PAGE.MARGIN_CALCULATOR}`}*/}
                {/*  onClick={(e) => onClickNavigate(e, PAGE.MARGIN_CALCULATOR)}*/}
                {/*>*/}
                {/*  Margin Calculator*/}
                {/*</Dropdown.Item>*/}
              </Dropdown.Menu>
            </Dropdown>

            <Nav.Item>
              <Nav.Link
                className={clsx("m-0", {
                  ["active"]: _.isEqual(
                    PAGE.USER_GUIDE,
                    _.get(history, ["location", "pathname"]),
                  ),
                })}
                href={`${PAGE.USER_GUIDE}`}
                onClick={(e) => onClickNavigate(e, PAGE.USER_GUIDE)}
              >
                <span className="d-lg-block">User Guide</span>
              </Nav.Link>
            </Nav.Item>

            <div className="divider"></div>
            <Dropdown
              as={Nav.Item}
              className="d-block d-lg-none d-xl-none d-xxl-none"
            >
              <Dropdown.Toggle
                as={Nav.Link}
                data-toggle="dropdown"
                id="dropdown-67443507"
                variant="default"
                className=" m-0 asButton"
              >
                <span className="d-lg-block text-primary">
                  {userSelectors.getUserAccountText(selectedAccount)}
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {!_.isEmpty(accountSelections)
                  ? _.map(accountSelections, (account, index) => {
                      const name = userSelectors.getUserAccountText(account);
                      const isSelected =
                        userSelectors.getUserAccountSelectionsCurrenciesIsSelected(
                          account,
                        );
                      return (
                        <Dropdown.Item
                          key={index}
                          href="#"
                          className={clsx("", {
                            ["text-primary"]: isSelected,
                          })}
                          onClick={(e) => onClickSwitchCode(e, name, "")}
                        >
                          {name}
                        </Dropdown.Item>
                      );
                    })
                  : false}
              </Dropdown.Menu>
            </Dropdown>
            <Dropdown
              as={Nav.Item}
              className="d-block d-lg-none d-xl-none d-xxl-none"
            >
              <Dropdown.Toggle
                as={Nav.Link}
                data-toggle="dropdown"
                id="dropdown-67443507"
                variant="default"
                className=" m-0 asButton"
              >
                <span className="d-lg-block text-primary">
                  {userSelectors.getUserAccountText(selectedCurrency)}
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {!_.isEmpty(currenciesSelections)
                  ? _.map(currenciesSelections, (currency, index) => {
                      const name = userSelectors.getUserAccountText(currency);
                    const key = userSelectors.getUserAccountKey(currency);

                    const isSelected =
                        userSelectors.getUserAccountSelectionsCurrenciesIsSelected(
                          currency,
                        );
                      return (
                        <Dropdown.Item
                          key={index}
                          href="#"
                          className={clsx("", {
                            ["text-primary"]: isSelected,
                          })}
                          onClick={(e) => onClickSwitchCode(e, "", key)}
                        >
                          {name}
                        </Dropdown.Item>
                      );
                    })
                  : false}
              </Dropdown.Menu>
            </Dropdown>
            <button
              className={clsx("btn btn-logout d-lg-none d-flex profile-icon")}
              onClick={(e) => onClickNavigate(e,PAGE.PROFILE)}
            >
              <FontAwesomeIcon icon={faUserCircle} size="xl" />
            </button>
            <div className="divider"></div>
            <button
              className={clsx("btn btn-logout d-lg-none mt-1 mb-0 ms-2")}
              onClick={() => onClickLogout()}
            >
              Logout
            </button>
          </Nav>
        </Navbar.Collapse>
      </Container>
      <CustomConfirmationModal
        title="Confirm Logout"
        desc="Are you confirm to logout?"
        handleClose={() => setShow(false)}
        confirm={startLogout}
        show={show}
        loading={loading}
      ></CustomConfirmationModal>
    </Navbar>
  );
}

export default Header;
